export const ReferralsAPI = {
    url: 'referrals/referralsbyuser',
    method: 'POST',
    responseSchema: null,
    requestSchema: null,
    queryParamsSchema: null,
    callErrorPage: false,
    storeKey: 'ReferralsAPI'
};

const CommonAPIs = [ReferralsAPI];

export default CommonAPIs;
